<template>
  <div id="aboutUs" class="sec">
    <div class="continer-fluid abautUs">
      <div class="imgBox">
        <img src="../../assets/webLogoGrande.svg" alt="" />
      </div>
      <div class="txtBox">
        <div class="MyContainer-fluid">
          <h1>Quiénes somos</h1>
        </div>
        <p>
          OverLab es una empresa desarrolladora de software cuyo principal
          objetivo es crear soluciones de base tecnológica que mejoren
          efectivamente la calidad de vida de la comunidad, optimizando procesos
          y utilizando la información para brindar apoyo estratégico a las
          organizaciones siendo apoyo para la toma de decisiones que den frente
          a la era de la información. Hemos demostrado que, una vez implementada
          una estrategia basada en TI, se mejoran los procesos organizacionales
          aumentando la dinámica competitiva, se desarrollan operaciones
          eficiente y eficazmente, con la flexibilidad necesaria para hacer
          frente al cambio, atendiendo y dando cumplimiento a los lineamientos
          del gobierno nacional.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.sec {
  width: 100%;
  min-height: auto;
}

.MyContainer-fluid {
  height: auto;
  width: 100%;
}

.MyContainer {
  height: auto;
  width: 90%;
  margin: 0 5%;
}

.MyContainer-fluid .title-center {
  background: var(--secondary);
  text-align: center;
  padding: 10px;
}

.MyContainer .title-center h1 {
  color: #fff;
}
.abautUs {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  padding: 0 25px;
}

.abautUs .imgBox {
  position: relative;
  width: 500px;
}

.abautUs .imgBox:before {
  content: "";
  position: absolute;
  right: 0;
  top: -1%;
  width: 400px;
  height: 100%;
  background: var(--back);
  transform-origin: top;
  transform: skewX(-25deg);
  z-index: 1;
}

.abautUs .imgBox img {
  position: relative;
  width: 100%;
  z-index: 100;
}

.abautUs .txtBox {
  position: relative;
  width: 500px;
}

.abautUs .txtBox h1 {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}
</style>
